/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Private modules
 */
import { scale } from '../.private';

/**
 * Styled components
 */
export default styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  > img, > span:not(:first-child) {
    margin-left: ${scale.major(1)}px;
  }
  > small {
    width: auto;
  }
  > svg:nth-child(2) {
    margin-left: ${scale.minor(1)}px;
    margin-right: ${scale.minor(1)}px;
  }
`;
